import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c8f66bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "loading",
  class: "modal justify-center flex text-center items-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "text-center animate-spin h-12 w-12 text-black",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      class: "opacity-25",
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "white",
      "stroke-width": "4"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "opacity-100",
      fill: "white",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    })
  ])
], -1))
const _hoisted_3 = { class: "mt-4 font-bold tracking-wide text-white drop-shadow-lg text-3xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ])
    ])
  ]))
}